import { IPartnerPlanData } from '../../../types';

export const calculateIsItrPlanActive = (
  eas_plans: string,
  eas_itr: string[] | undefined
): boolean => {
  if (eas_plans === 'non_itr') {
    return false;
  }

  return !!eas_itr && eas_itr.length > 0;
};

export const parnterPlanTransformer = (planDetails: IPartnerPlanData[]) => {
  return planDetails.map((input) => {
    const { coupon, ...rest } = input;

    return {
      externalId: rest.planDetails.planId,
      ...rest,
      autoApplicableCoupon: coupon,
    };
  });
};
